import React from 'react';

import { PortalPlace } from '@interlayer/js/app/components/system/Portal/components/PortalPlace';

import { clsx } from '@interlayer/js/app/utils/clsx.util';

import { BOTTOM_STICKY_IDS } from './constants';

import style from './BottomStickyElements.scss';

export const BottomStickyElements = () => {
    return (
        <div className={style.container}>
            {Object.entries(BOTTOM_STICKY_IDS).map(([key, id]) => {
                return (
                    <PortalPlace
                        id={id}
                        key={key}
                        isHideAdminPanel
                        className={clsx(style.element, style[key])}
                    />
                );
            })}
        </div>
    );
};
